import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-106915b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "switch-line-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tips-box" }, "一个店铺只能有一个默认仓库，订单发货时会自动带出它的发货人信息", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips-box form-tips-box" }, " 发货人信息会作为快递电子面单的寄件人，选择「快递发货」时必填 ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "submit-fixed-wrap-placeholder" }, null, -1))
const _hoisted_5 = { class: "submit-fixed-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_ui_area_select = _resolveComponent("ui-area-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_ui_container = _resolveComponent("ui-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_container, { class: "com-wrap-box" }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_ui_form, {
        ref: "form",
        "label-position": "right",
        "label-width": "150px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ui_card, null, {
            title: _withCtx(() => [
              _createVNode(_component_ui_title, { title: "基本信息" })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_ui_form_item, {
                label: "仓库名称",
                required: true,
                data: _ctx.formData.name,
                error: "请输入仓库名称"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                    placeholder: "请输入仓库名称",
                    style: {"max-width":"400px"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(_component_ui_form_item, { label: "默认仓库" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_el_switch, {
                      modelValue: _ctx.formData.isDefault,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.isDefault) = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_2
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ui_card, null, {
            title: _withCtx(() => [
              _createVNode(_component_ui_title, { title: "发货人信息" })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_ui_form_item, {
                label: "发货人姓名",
                required: true,
                data: _ctx.formData.senderName,
                error: "请输入发货人姓名"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.senderName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.senderName) = $event)),
                    placeholder: "请输入发货人姓名",
                    style: {"max-width":"400px"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(_component_ui_form_item, {
                label: "发货人手机号",
                required: true,
                data: _ctx.formData.senderMobile,
                error: "请输入发货人手机号"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.senderMobile,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.senderMobile) = $event)),
                    placeholder: "请输入发货人手机号",
                    style: {"max-width":"400px"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(_component_ui_form_item, {
                label: "发货地区",
                required: true,
                data: _ctx.areaValue,
                error: "请选择发货地区"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ui_area_select, {
                    modelValue: _ctx.areaValue,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.areaValue) = $event)),
                    placeholder: "请选择发货地区",
                    style: {"max-width":"400px"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["data"]),
              _createVNode(_component_ui_form_item, {
                label: "详细地址",
                required: true,
                data: _ctx.formData.address,
                error: "请输入详细地址"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.address,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.address) = $event)),
                    type: "textarea",
                    placeholder: "请输入详细地址",
                    style: {"max-width":"400px"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["data"]),
              _hoisted_3
            ]),
            _: 1
          }),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              onClick: _ctx.submit,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }, 8, ["onClick"])), [
              [_directive_loading, _ctx.submitLoading]
            ])
          ])
        ]),
        _: 1
      })), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }))
}